const PT = require("prop-types");
const createReactClass = require("create-react-class");

// We redirect to this page right after user is logged in.
// This page then determins where to redirect user after checking their roles.
module.exports = createReactClass({
	displayName: "PagePostSignin",

	propTypes: {
		user: PT.object.isRequired,
	},

	render: function() {
		// Show a pretty empty page while waiting for redirect
		return null;
	},
});
